import { IDriverCreate, IDriverListSearch, IEditDriverPayload } from "../../../../types/master/driverInterface"
import api from "../../../../lib/api"


export const createDriverApi = async (data: IDriverCreate) => {
  return await api.post(`/driver`, data)
}

export const getDriverListApi = async (data: IDriverListSearch) => {
  return await api.get(`/driver/${data.page}/${data.pageLimit}?search=${data?.search??""}`)
}

export const getDriverDataByIdApi = async (id: number) => {
  return await api.get(`/driver/${id}`)
}

export const editDriverDataByIdApi = async (payload: IEditDriverPayload) => {
  return await api.put(`/driver/${payload.id}`, payload.data);
};